<template>
  <div class="payment-container">

    <div class="personal-details flex">
      <div class="billing">
        <h6>Billing Details</h6>
        <p>
          {{ cart.billing_info.first_name }}
          {{ cart.billing_info.last_name }}
        </p>
        <p>{{ cart.billing_info.phone }}</p>
        <p>{{ cart.billing_info.email }}</p>
        <br/>
        <p>
          {{ cart.billing_info.line_1 }}, <br />
          {{ cart.billing_info.suburb }}, {{ cart.billing_info.city }}<br/>
          {{ cart.billing_info.region_name }} {{ cart.billing_info.post_code }}<br/>
        </p>
      </div>

      <div class="shipping">
        <h6>Shipping Details</h6>
        <p>
          {{ cart.shipping_info.first_name }}
          {{ cart.shipping_info.last_name }}
        </p>
        <p>{{ cart.shipping_info.phone }}</p>
        <p>{{ cart.shipping_info.email }}</p>
        <br/>
        <p>
          {{ cart.shipping_info.line_1 }}, <br />
          {{ cart.shipping_info.suburb }}, {{ cart.shipping_info.city }} <br />
          {{ cart.shipping_info.region_name }} {{ cart.shipping_info.post_code }}<br />
        </p>
      </div>
    </div>

    <div class="order-items">
      <div
        v-for="item in $store.state.cart.items"
        :key="item.id"
        class="product flex"
      >
        <div class="left">
          <img :alt="item.title" class="lazyload" :src="item.image"/>
        </div>
        <div class="right">
          <p class="title">{{ item.title }}</p>
          <p class="price">Price: {{ modFormatDollarAmount(item.price) }}</p>
          <p>Quantity: {{ item.qty }}</p>
        </div>
      </div>
    </div>

    <div class="order-summary">

      <div class="row flex">
        <div class="left">
          Subtotal
          <span v-if="$store.state.cart.settings.tax_inclusive">
            Includes GST of $
            <span class="js-gst">{{ modFormatAmount(cart.summary.tax_total) }}</span>
          </span>
        </div>
        <div class="right">
          <strong>
            $<span class="js-subtotal">{{ modFormatAmount(cart.summary.sub_total) }}</span>
          </strong>
        </div>
      </div>

      <div class="row flex">
        <div class="left">
          Shipping
        </div>
        <div class="right">
          <strong>
            $<span class="js-shipping">{{ modFormatAmount(cart.summary.shipping) }}</span>
          </strong>
        </div>
      </div>

      <div
        v-if="!$store.state.cart.settings.tax_inclusive"
        class="row flex"
      >
        <div class="left">
          GST
        </div>
        <div class="right">
          <strong>
            $<span class="js-subtotal">{{ modFormatAmount(cart.summary.tax_total) }}</span>
          </strong>
        </div>
      </div>

      <div class="row flex">
        <div class="left">
          Total
        </div>
        <div class="right">
          <strong>
            $<span class="js-total">{{ modFormatAmount(cart.summary.total) }}</span>
          </strong>
        </div>
      </div>

    </div>

    <div class="accept-me form-field">

      <div class="custom-checkbox-radio">
        <label class="accept-label">
          <input type="checkbox" v-model="isAccepted" />
          <a href="/terms-and-conditions" target="_blank">I accept the terms & conditions</a>
        </label>
      </div>

    </div>

    <div class="checkout-step-footer">
      <button
        @click="goBack()"
        :disabled="disableButton"
        class="button">
        Back
      </button>

      <button
        @click="pay('pxpay')"
        :disabled="disableButton"
        class="button orange">
        Pay with Credit Card
      </button>

      <button
        v-if="hasOnAccount"
        @click="pay('on-account')"
        :disabled="disableButton"
        class="button green">
        On Account
      </button>
    </div>

  </div>
</template>

<script>
export default {
  props: {
    type: String,
    countries: Array,
    regions: Array,
    cashSaleOnly: Number,
  },

  data () {
    return {
      isAccepted: false,
      disableButton: false
    }
  },

  computed: {
    cart () {
      return this.$store.state.cart
    },

    isLoggedIn () {
      return this.$store.state.is_logged_in
    },

    hasOnAccount () {
      if (this.$store.state.is_logged_in) {
        if (this.cashSaleOnly === 0) {
          return true
        }
      }
      return false
    }
  },

  methods: {
    getCountryName (id) {
      if (id) {
        let object = this.countries.find(x => x.id === id)
        if (object) {
          return object.title
        }
      }

      return ''
    },

    getRegionName (id) {
      if (id) {
        let object = this.regions.find(x => x.id === id)
        if (object) {
          return object.name
        }
      }
      return ''
    },

    goBack () {
      this.$emit("emitStep", 2)
    },

    pay (paymentType) {
      if (!this.isAccepted) {
        this.$store.commit('setPopup', {
          open: true,
          content: '<p>Please indicate that you have read and agree to the Terms and Conditions</p>'
        })

        return
      }

      this.disableButton = true

      window.axios.post('/api/payment/' + paymentType)
        .then(response => {
          if (response.data.success) {
            // redirect to pxpay hosted payment page
            window.location.href = response.data.url
          } else {
            this.disableButton = false
            this.$store.commit('setPopup', {
              open: true,
              content: '<p>' + response.data.message + '</p>'
            })
          }
        })
        .catch(error => {
          this.disableButton = false
          this.$store.commit('setPopup', {
            open: true,
            content: '<p>An error occurred while connecting to the ' + action + ' gateway. Please check your account first if it has been charged. If so, please contact us.</p>'
          })
        })
    }

  }
};
</script>
<style lang="scss">
.payment-container {

  h6 {
    font-weight: 600;
    // text-transform: uppercase;
  }

  p {
    margin-bottom: 0;

    font-size: 14px;
    line-height: 22px;
  }

  .personal-details {
    width: 100%;
    max-width: 400px;

    .billing, .shipping {
      width: 50%;
    }
  }

  .order-items {
    width: 100%;
    padding: 40px 0;

    .product {
      align-items: center;
      width: 100%;
      padding: 5px 0;

      .left {
        max-width: 90px;
      }

      .right {
        padding: 0 20px;
      }
    }
  }

  .order-summary {
    padding-bottom: 20px;

    .row {
      width: 100%;
      max-width: 400px;
      padding: 5px 0;

      .left,
      .right {
        width: 50%;
      }
    }
  }

  .accept-label {
    padding: 0 0 15px;
    margin-bottom: 0;

    input {
        margin-top: 0;
    }
  }

  .checkout-step-footer {
    .button {
      max-width: 200px !important;
    }
  }
}
</style>


// WEBPACK FOOTER //
// resources/assets/frontend/js/modulatte-cart/components/Payment.vue